// src/data/blogData.js

/* =========================================================
   Helper: Rich HTML content blocks (simple, no markdown lib)
   - You can later replace with real CMS or MDX.
   - Keep it as HTML string so BlogDetail can render it.
========================================================= */
import one from '../../Images/blog/1.png';
import two from '../../Images/blog/2.png';
const CONTENT = {
  webdesign_erster_eindruck: `
    <p>Der erste Eindruck entscheidet – und das gilt online oft innerhalb weniger Sekunden. Professionelles Webdesign sorgt dafür, dass Besucher sofort Vertrauen aufbauen und sich intuitiv zurechtfinden.</p>
    <h2>Warum Webdesign mehr als „schön“ sein muss</h2>
    <ul>
      <li><strong>Struktur:</strong> Klare Navigation, logische Seitenhierarchie und Fokus auf das Wesentliche.</li>
      <li><strong>Lesbarkeit:</strong> Typografie, Kontraste und Abstände machen Inhalte schnell erfassbar.</li>
      <li><strong>Vertrauen:</strong> Qualität im Design wird unbewusst mit Qualität im Angebot gleichgesetzt.</li>
    </ul>
    <h2>Conversion: Design, das Anfragen erzeugt</h2>
    <p>Ein gutes Layout lenkt Nutzer gezielt zu Handlungen: Kontakt, Anfrage, Terminbuchung. Dafür braucht es klare Call-to-Actions, passende Inhalte und eine konsistente visuelle Sprache.</p>
    <h2>Praxis-Tipps</h2>
    <ol>
      <li>Startseite: Nutzenversprechen in einem Satz + klarer CTA.</li>
      <li>Referenzen/Trust: Kundenlogos, Bewertungen, Case Studies.</li>
      <li>Performance: Schnelle Ladezeiten (Images optimieren, sauberes Frontend).</li>
    </ol>
    <p><em>Fazit:</em> Professionelles Webdesign ist ein Wachstumstreiber – nicht nur ein „Nice-to-have“.</p>
  `,

  crm_automatisierung_effizienz: `
    <p>Wachsende Unternehmen verlieren häufig Zeit durch manuelle Aufgaben: Nachfassen, Datenpflege, Status-Updates, Übergaben. CRM-Automatisierung schafft Ordnung und sorgt dafür, dass Prozesse verlässlich laufen.</p>
    <h2>Was CRM-Automatisierung in der Praxis bedeutet</h2>
    <ul>
      <li><strong>Leads automatisch erfassen</strong> (Formulare, Mails, CRM-Importe)</li>
      <li><strong>Workflows</strong> für Follow-ups und Erinnerungen</li>
      <li><strong>Transparenz</strong> über Pipeline, Zuständigkeiten und Prioritäten</li>
    </ul>
    <h2>Typische Effekte</h2>
    <p>Unternehmen berichten oft von weniger „Nachfragen intern“, mehr Abschlüssen durch schnelle Reaktionszeiten und einer besseren Datenqualität.</p>
    <h2>So starten Sie sinnvoll</h2>
    <ol>
      <li>Prozess aufnehmen (Ist-Zustand)</li>
      <li>Engpass identifizieren (z. B. Follow-up)</li>
      <li>Workflow automatisieren + messen (Zeit/Conversion)</li>
    </ol>
    <p><em>Fazit:</em> CRM-Automatisierung ist die Basis für skalierbaren Vertrieb und saubere Abläufe.</p>
  `,

  google_bewertungen_loeschen: `
    <p>Negative Bewertungen können Umsatz kosten – aber nicht jede Bewertung ist „rechtens“. Entscheidend ist, ob Inhalte gegen Richtlinien verstoßen oder unzulässig sind.</p>
    <h2>Wann ist eine Löschung möglich?</h2>
    <ul>
      <li><strong>Beleidigungen/Schmähkritik</strong> oder diskriminierende Sprache</li>
      <li><strong>Fake Reviews</strong> ohne echten Kundenkontakt</li>
      <li><strong>Falsche Tatsachenbehauptungen</strong> (nachweisbar)</li>
      <li><strong>Datenschutzverletzungen</strong> (Klarnamen, sensible Daten)</li>
    </ul>
    <h2>Vorgehen in 3 Schritten</h2>
    <ol>
      <li>Bewertung prüfen und Beweise sammeln (Screenshots, Unterlagen).</li>
      <li>Melden mit klarer Begründung (Richtlinienbezug).</li>
      <li>Alternativ: Professionell antworten, wenn Löschung nicht möglich ist.</li>
    </ol>
    <p><em>Fazit:</em> Mit der richtigen Strategie lassen sich unzulässige Bewertungen oft entfernen – der Rest wird aktiv gemanagt.</p>
  `,

  local_listing_optimieren: `
    <p>Local Listing ist einer der wichtigsten Hebel für lokale Sichtbarkeit. Ein gepflegtes Profil sorgt für mehr Anrufe, Routenanfragen und Website-Klicks – ohne zusätzliche Werbekosten.</p>
    <h2>Was gehört zu Local Listing?</h2>
    <ul>
      <li><strong>NAP-Konsistenz:</strong> Name, Adresse, Telefonnummer überall identisch.</li>
      <li><strong>Google Unternehmensprofil:</strong> Öffnungszeiten, Kategorien, Leistungen, Fotos.</li>
      <li><strong>Einträge:</strong> Branchenverzeichnisse, Kartenanbieter, lokale Portale.</li>
    </ul>
    <h2>Die häufigsten Fehler</h2>
    <ul>
      <li>Falsche Öffnungszeiten</li>
      <li>Doppelte Einträge</li>
      <li>Unpassende Kategorien</li>
      <li>Zu wenige aktuelle Fotos</li>
    </ul>
    <p><em>Fazit:</em> Wer Local Listing ernst nimmt, gewinnt dauerhaft Sichtbarkeit in Google & Maps.</p>
  `,

  react_node_vorteile: `
    <p>React & Node.js sind eine bewährte Kombination für moderne Webanwendungen: schnell, skalierbar und flexibel. Gerade Unternehmen profitieren von modularen Systemen, die mitwachsen.</p>
    <h2>Warum React?</h2>
    <ul>
      <li><strong>Komponenten:</strong> Wiederverwendbare UI-Bausteine sparen Entwicklungszeit.</li>
      <li><strong>Performance:</strong> Schnelle, interaktive Nutzererlebnisse.</li>
      <li><strong>Skalierung:</strong> Große Apps bleiben strukturiert und wartbar.</li>
    </ul>
    <h2>Warum Node.js?</h2>
    <ul>
      <li><strong>API-first:</strong> Ideal für Integrationen (CRM, Zahlungsanbieter, Tools).</li>
      <li><strong>Echtzeit:</strong> Chats, Dashboards, Status-Updates.</li>
      <li><strong>One Language:</strong> JavaScript im Frontend und Backend.</li>
    </ul>
    <p><em>Fazit:</em> Mit React & Node entstehen Lösungen, die langfristig erweiterbar und wirtschaftlich sind.</p>
  `,

  automatisierung_wachstum: `
    <p>Automatisierung ist kein „Tool-Thema“, sondern ein Wachstumsprinzip. Wer wiederkehrende Prozesse standardisiert und automatisiert, spart Ressourcen und kann schneller reagieren.</p>
    <h2>Die größten Vorteile</h2>
    <ul>
      <li><strong>Zeitgewinn</strong> durch reduzierte manuelle Aufgaben</li>
      <li><strong>Fehlerreduktion</strong> durch klare Standards</li>
      <li><strong>Skalierbarkeit</strong> ohne proportional mehr Personal</li>
    </ul>
    <h2>Wo lohnt es sich besonders?</h2>
    <ol>
      <li>Lead-Management & Follow-ups</li>
      <li>Angebots- und Rechnungsprozesse</li>
      <li>Onboarding & interne Übergaben</li>
    </ol>
    <p><em>Fazit:</em> Automatisierung macht Wachstum planbar – und Teams produktiver.</p>
  `,

  conversion_webdesign_dienstleister: `
    <p>Dienstleister brauchen Websites, die nicht nur informieren, sondern aktiv neue Anfragen erzeugen. Conversion-starkes Webdesign kombiniert Klarheit, Vertrauen und Nutzerführung.</p>
    <h2>Die Conversion-Formel</h2>
    <ul>
      <li><strong>Problem</strong> klar benennen</li>
      <li><strong>Lösung</strong> einfach erklären</li>
      <li><strong>Beweis</strong> durch Referenzen/Ergebnisse</li>
      <li><strong>CTA</strong> sichtbar und wiederholt platzieren</li>
    </ul>
    <h2>Checkliste</h2>
    <ol>
      <li>Hero mit Nutzen + CTA</li>
      <li>Leistungsübersicht mit klaren Ergebnissen</li>
      <li>FAQ gegen Einwände</li>
    </ol>
    <p><em>Fazit:</em> Für Dienstleister ist die Website oft der beste Vertriebskanal – wenn sie richtig aufgebaut ist.</p>
  `,

  crm_vertrieb_entlasten: `
    <p>Ein CRM entlastet Vertriebsteams, indem es Routinearbeit reduziert und Informationen im System hält. So wird aus „Nachfragen & Excel“ ein klarer, messbarer Prozess.</p>
    <h2>Was ein gutes CRM wirklich leistet</h2>
    <ul>
      <li><strong>Pipeline-Transparenz:</strong> Jeder Deal hat Status, Verantwortliche und nächste Schritte.</li>
      <li><strong>Automatische Aufgaben:</strong> Follow-up, Erinnerungen, Mails, Notizen.</li>
      <li><strong>Reporting:</strong> Umsatzprognosen und Engpässe erkennbar.</li>
    </ul>
    <p><em>Fazit:</em> Mit CRM-Workflows steigt die Abschlussquote – weil konsequent nachverfolgt wird.</p>
  `,

  rufmanagement_bewertungen: `
    <p>Online-Bewertungen sind einer der wichtigsten Vertrauensfaktoren. Ein aktives Rufmanagement schützt die Marke und erhöht die Abschlusswahrscheinlichkeit.</p>
    <h2>Was gutes Rufmanagement beinhaltet</h2>
    <ul>
      <li>Bewertungen regelmäßig monitoren</li>
      <li>Professionell antworten (auch bei Kritik)</li>
      <li>Mehr echte Bewertungen generieren</li>
      <li>Unzulässige Reviews strukturiert prüfen und melden</li>
    </ul>
    <p><em>Fazit:</em> Wer Bewertungen aktiv steuert, gewinnt Vertrauen – und reduziert Risiko.</p>
  `,

  lokale_anfragen_unternehmenseintraege: `
    <p>Optimierte Unternehmenseinträge bringen lokale Anfragen – ohne Ads. Wichtig sind Konsistenz, Aktualität und starke Signale (Fotos, Kategorien, Bewertungen).</p>
    <h2>Die 4 Hebel</h2>
    <ol>
      <li>NAP-Daten konsistent halten</li>
      <li>Unternehmensbeschreibung + Leistungen optimieren</li>
      <li>Regelmäßig Fotos/Beiträge aktualisieren</li>
      <li>Bewertungen aktiv aufbauen</li>
    </ol>
    <p><em>Fazit:</em> Local Listing ist ein dauerhafter SEO-Boost für lokale Anbieter.</p>
  `,

  individuelle_webentwicklung_guenstiger: `
    <p>Individuelle Webentwicklung wirkt zunächst teurer – ist aber langfristig oft günstiger, weil sie besser passt, schneller ist und flexibel erweitert werden kann.</p>
    <h2>Warum Baukästen teuer werden können</h2>
    <ul>
      <li>Limitierte Funktionen → Workarounds</li>
      <li>Performance-Probleme</li>
      <li>Abhängigkeit von Plugins/Anbietern</li>
    </ul>
    <h2>Wann lohnt sich Custom Development?</h2>
    <p>Wenn Prozesse individuell sind, Integrationen nötig sind oder Wachstum geplant ist, zahlt sich eine maßgeschneiderte Lösung aus.</p>
    <p><em>Fazit:</em> Custom Webentwicklung ist eine Investition in Skalierbarkeit.</p>
  `,

  lead_nachverfolgung_automatisieren: `
    <p>Leads gehen oft nicht verloren, weil das Angebot schlecht ist, sondern weil Nachverfolgung fehlt. Automatisierung sorgt dafür, dass jeder Kontakt einen nächsten Schritt bekommt.</p>
    <h2>Typische Automationen</h2>
    <ul>
      <li>Auto-Reminder nach 24/48 Stunden</li>
      <li>Status-Wechsel mit Aufgaben</li>
      <li>Vorlagen für E-Mails / WhatsApp</li>
      <li>Benachrichtigungen fürs Team</li>
    </ul>
    <p><em>Fazit:</em> Automatisiertes Follow-up erhöht Abschlüsse spürbar – ohne mehr Personal.</p>
  `,

  mobile_optimierung_unverzichtbar: `
    <p>Mobile ist Standard. Wer mobil nicht überzeugt, verliert Nutzer – und Ranking. Responsive Design ist heute Pflicht, nicht Kür.</p>
    <h2>Was „mobile optimiert“ wirklich heißt</h2>
    <ul>
      <li>Touch-freundliche Buttons</li>
      <li>Schnelle Ladezeiten</li>
      <li>Lesbare Typografie</li>
      <li>Optimierte Bilder</li>
    </ul>
    <p><em>Fazit:</em> Mobile Optimierung ist einer der schnellsten Conversion-Booster.</p>
  `,

  google_unternehmensprofil_pflegen: `
    <p>Das Google Unternehmensprofil ist oft der erste Kontaktpunkt. Aktualität (Öffnungszeiten, Fotos, Beiträge) wirkt direkt auf Klicks, Anrufe und Routenanfragen.</p>
    <h2>Was Sie regelmäßig pflegen sollten</h2>
    <ul>
      <li>Öffnungszeiten (auch Feiertage)</li>
      <li>Neue Fotos (Team, Standort, Arbeit)</li>
      <li>Beiträge / Angebote</li>
      <li>Fragen & Antworten</li>
    </ul>
    <p><em>Fazit:</em> Kontinuität ist hier wichtiger als Perfektion.</p>
  `,

  negative_bewertungen_managen: `
    <p>Negative Bewertungen zu ignorieren ist ein Fehler. Professionelles Management zeigt Haltung, erhöht Vertrauen und kann die Wahrnehmung komplett drehen.</p>
    <h2>So antworten Sie richtig</h2>
    <ul>
      <li>Sachlich bleiben, keine Schuldzuweisungen</li>
      <li>Problem anerkennen und Lösung anbieten</li>
      <li>Offline-Kontakt anbieten (E-Mail/Telefon)</li>
    </ul>
    <p><em>Fazit:</em> Eine gute Antwort kann mehr Vertrauen erzeugen als eine 5-Sterne-Bewertung.</p>
  `,
};

export const featuredCards = [
  {
    slug: "professionelles-webdesign-erster-eindruck",
    title: "Professionelles Webdesign: Warum der erste Eindruck entscheidet",
    excerpt:
      "Ein modernes, nutzerfreundliches Webdesign ist heute entscheidend für Vertrauen, Conversion und Markenwirkung. Wir zeigen, worauf es wirklich ankommt.",
    date: "1. Februar 2024",
    tag: "Webdesign",
    img: one,
    authorName: "Max Müller",
    authorAvatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80",
    content: CONTENT.webdesign_erster_eindruck,
    category: "web-design",
    tags: ["web-design", "ki-automation", "reviews"],

    readingTime: "5 Minuten gelesen",
  },
  {
    slug: "crm-automatisierung-effizienz-wachstum",
    title: "CRM-Automatisierung: Mehr Effizienz für wachsende Unternehmen",
    excerpt:
      "Manuelle Prozesse kosten Zeit und Geld. Mit einer intelligenten CRM-Automatisierung optimieren Sie Vertrieb, Support und interne Abläufe nachhaltig.",
    date: "10. Februar 2024",
    tag: "CRM Automatisierung",
    img: "https://images.unsplash.com/photo-1556155092-8707de31f9c4?auto=format&fit=crop&w=1200&q=80",
    authorName: "Laura Schneider",
    authorAvatar:
      "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=200&q=80",
    content: CONTENT.crm_automatisierung_effizienz,
    category: "web-design",
    tags: ["web-design", "ki-automation", "reviews"],

    readingTime: "5 Minuten gelesen",
  },
];

/* =========================
   RIGHT SIDE (Latest Articles)
========================= */
export const items = [
  {
    slug: "negative-google-bewertungen-loeschen-was-moeglich-ist",
    title: "Negative Google-Bewertungen löschen – was ist wirklich möglich?",
    excerpt:
      "Nicht jede schlechte Bewertung muss bleiben. Erfahren Sie, wann eine Löschung möglich ist und welche rechtlichen Voraussetzungen erfüllt sein müssen.",
    date: "05. Februar 2024",
    tag: "Bewertungen",
    img: "https://images.unsplash.com/photo-1545235617-9465d2a55698?auto=format&fit=crop&w=400&q=80",
    authorName: "Daniel Weber",
    authorAvatar:
      "https://images.unsplash.com/photo-1544723795-3fb6469f5b39?auto=format&fit=crop&w=200&q=80",
    content: CONTENT.google_bewertungen_loeschen,
    category: "web-design",
    tags: ["web-design", "ki-automation", "reviews"],

    readingTime: "5 Minuten gelesen",
  },
  {
    slug: "local-listing-optimieren-mehr-sichtbarkeit-google-maps",
    title: "Local Listing optimieren: Mehr Sichtbarkeit bei Google & Maps",
    excerpt:
      "Ein gepflegtes Unternehmensprofil sorgt für bessere Rankings und mehr Anfragen. Wir zeigen, wie Local Listing richtig funktioniert.",
    date: "9. Februar 2024",
    tag: "Local Listing",
    img: two,
    authorName: "Sophie Klein",
    authorAvatar:
      "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=200&q=80",
    content: CONTENT.local_listing_optimieren,
    category: "web-design",
    tags: ["web-design", "ki-automation", "reviews"],

    readingTime: "5 Minuten gelesen",
  },
  {
    slug: "webentwicklung-react-nodejs-vorteile-fuer-unternehmen",
    title: "Webentwicklung mit React & Node.js: Vorteile für Unternehmen",
    excerpt:
      "Moderne Webanwendungen müssen schnell, skalierbar und sicher sein. React und Node.js bieten dafür die ideale technologische Basis.",
    date: "10. Februar 2024",
    tag: "Webentwicklung",
    img: "https://images.unsplash.com/photo-1515879218367-8466d910aaa4?auto=format&fit=crop&w=400&q=80",
    authorName: "Jan Hoffmann",
    authorAvatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80",
    content: CONTENT.react_node_vorteile,
    category: "web-design",
    tags: ["web-design", "ki-automation", "reviews"],

    readingTime: "5 Minuten gelesen",
  },
  {
    slug: "warum-automatisierung-schluessel-skalierbares-wachstum",
    title: "Warum Automatisierung der Schlüssel zu skalierbarem Wachstum ist",
    excerpt:
      "Unternehmen, die Prozesse automatisieren, sparen Ressourcen und reagieren schneller auf Marktveränderungen. Ein Überblick über die wichtigsten Vorteile.",
    date: "11. Februar 2024",
    tag: "Automatisierung",
    img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=400&q=80",
    authorName: "Max Müller",
    authorAvatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80",
    content: CONTENT.automatisierung_wachstum,
    category: "web-design",
    tags: ["web-design", "ki-automation", "reviews"],

    readingTime: "5 Minuten gelesen",
  },
];

/* =========================
   BOTTOM (All Articles – Pagination)
========================= */
export const POSTS = [
  {
    slug: "conversion-starkes-webdesign-fuer-dienstleister",
    tag: "Webdesign",
    title: "Conversion-starkes Webdesign für Dienstleister",
    excerpt:
      "Eine gut gestaltete Website überzeugt nicht nur optisch, sondern generiert aktiv neue Kundenanfragen.",
    author: "Laura Schneider",
    authorAvatar:
      "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=200&q=80",
    date: "12. Februar 2024",
    image:
      "https://images.unsplash.com/photo-1492724441997-5dc865305da7?auto=format&fit=crop&w=1200&q=80",
    content: CONTENT.conversion_webdesign_dienstleister,
    category: "web-design",
    tags: ["web-design", "ki-automation", "reviews"],

    readingTime: "5 Minuten gelesen",
  },
  {
    slug: "wie-ein-crm-ihr-vertriebsteam-entlastet",
    tag: "CRM Automatisierung",
    title: "Wie ein CRM Ihr Vertriebsteam entlastet",
    excerpt:
      "Automatisierte Workflows sorgen für klare Prozesse, bessere Nachverfolgung und höhere Abschlussquoten.",
    author: "Max Müller",
    authorAvatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80",
    date: "12. Februar 2024",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1200&q=80",
    content: CONTENT.crm_vertrieb_entlasten,
    category: "web-design",
    tags: ["web-design", "ki-automation", "reviews"],

    readingTime: "5 Minuten gelesen",
  },
  {
    slug: "rufmanagement-warum-online-bewertungen-entscheidend-sind",
    tag: "Bewertungen",
    title: "Rufmanagement: Warum Online-Bewertungen entscheidend sind",
    excerpt:
      "Potenzielle Kunden informieren sich online. Ein professionelles Bewertungsmanagement schützt Ihre Marke.",
    author: "Daniel Weber",
    authorAvatar:
      "https://images.unsplash.com/photo-1544723795-3fb6469f5b39?auto=format&fit=crop&w=200&q=80",
    date: "08. Februar 2024",
    image:
      "https://images.unsplash.com/photo-1556740738-b6a63e27c4df?auto=format&fit=crop&w=1200&q=80",
    content: CONTENT.rufmanagement_bewertungen,
    category: "web-design",
    tags: ["web-design", "ki-automation", "reviews"],

    readingTime: "5 Minuten gelesen",
  },
  {
    slug: "mehr-lokale-anfragen-durch-optimierte-unternehmenseintraege",
    tag: "Local Listing",
    title: "Mehr lokale Anfragen durch optimierte Unternehmenseinträge",
    excerpt:
      "Einheitliche und aktuelle Firmendaten auf allen Plattformen erhöhen Ihre lokale Reichweite erheblich.",
    author: "Sophie Klein",
    authorAvatar:
      "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=200&q=80",
    date: "02. Februar 2024",
    image:
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1200&q=80",
    content: CONTENT.lokale_anfragen_unternehmenseintraege,
    category: "web-design",
    tags: ["web-design", "ki-automation", "reviews"],

    readingTime: "5 Minuten gelesen",
  },
  {
    slug: "warum-individuelle-webentwicklung-langfristig-guenstiger-ist",
    tag: "Webentwicklung",
    title: "Warum individuelle Webentwicklung langfristig günstiger ist",
    excerpt:
      "Maßgeschneiderte Lösungen sparen langfristig Kosten und lassen sich flexibel erweitern.",
    author: "Jan Hoffmann",
    authorAvatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80",
    date: "10. Februar 2024",
    image:
      "https://images.unsplash.com/photo-1515879218367-8466d910aaa4?auto=format&fit=crop&w=1200&q=80",
    content: CONTENT.individuelle_webentwicklung_guenstiger,
    category: "web-design",
    tags: ["web-design", "ki-automation", "reviews"],

    readingTime: "5 Minuten gelesen",
  },

  // ➕ NEU (6–9)
  {
    slug: "lead-nachverfolgung-automatisieren-abschluesse-steigern",
    tag: "CRM Automatisierung",
    title: "Lead-Nachverfolgung automatisieren und Abschlüsse steigern",
    excerpt:
      "Mit automatischen Erinnerungen und Status-Updates geht keine Anfrage mehr verloren.",
    author: "Thomas Berger",
    authorAvatar:
      "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?auto=format&fit=crop&w=200&q=80",
    date: "07. Februar 2024",
    image:
      "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1200&q=80",
    content: CONTENT.lead_nachverfolgung_automatisieren,
    category: "web-design",
    tags: ["web-design", "ki-automation", "reviews"],

    readingTime: "5 Minuten gelesen",
  },
  {
    slug: "warum-mobile-optimierung-heute-unverzichtbar-ist",
    tag: "Webdesign",
    title: "Warum mobile Optimierung heute unverzichtbar ist",
    excerpt:
      "Mehr als 70 % der Nutzer besuchen Websites mobil – ein responsives Design ist kein Extra mehr.",
    author: "Anna Richter",
    authorAvatar:
      "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?auto=format&fit=crop&w=200&q=80",
    date: "06. Februar 2024",
    image:
      "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1200&q=80",
    content: CONTENT.mobile_optimierung_unverzichtbar,
    category: "web-design",
    tags: ["web-design", "ki-automation", "reviews"],

    readingTime: "5 Minuten gelesen",
  },
  {
    slug: "google-unternehmensprofil-richtig-pflegen",
    tag: "Local Listing",
    title: "Google Unternehmensprofil richtig pflegen",
    excerpt:
      "Fotos, Öffnungszeiten und Beiträge regelmäßig aktualisieren – so bleiben Sie lokal sichtbar.",
    author: "Michael Braun",
    authorAvatar:
      "https://images.unsplash.com/photo-1527980965255-d3b416303d12?auto=format&fit=crop&w=200&q=80",
    date: "11. Februar 2024",
    image:
      "https://images.unsplash.com/photo-1557426272-fc759fdf7a8d?auto=format&fit=crop&w=1200&q=80",
    content: CONTENT.google_unternehmensprofil_pflegen,
    category: "web-design",
    tags: ["web-design", "ki-automation", "reviews"],

    readingTime: "5 Minuten gelesen",
  },
  {
    slug: "negative-bewertungen-richtig-managen-statt-ignorieren",
    tag: "Bewertungen",
    title: "Negative Bewertungen richtig managen statt ignorieren",
    excerpt:
      "Professionelle Antworten und gezielte Maßnahmen stärken Vertrauen und Glaubwürdigkeit.",
    author: "Katrin Meier",
    authorAvatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80",
    date: "10. Februar 2024",
    image:
      "https://images.unsplash.com/photo-1545235617-9465d2a55698?auto=format&fit=crop&w=1200&q=80",
    content: CONTENT.negative_bewertungen_managen,
    category: "web-design",
    tags: ["web-design", "ki-automation", "reviews"],

    readingTime: "5 Minuten gelesen",
  },
];

/* =========================
   OPTIONAL: One unified array for detail page lookup
   (recommended so you can search across ALL cards)
========================= */
export const ALL_BLOGS = [
  ...featuredCards.map((p) => ({
    ...p,
    image: p.img, // normalize
    author: p.authorName,
  })),
  ...items.map((p) => ({
    ...p,
    image: p.img, // normalize
    author: p.authorName,
  })),
  ...POSTS,
];
